import { useTranslation } from 'react-i18next';
import { BottomSheet } from '@/components/BottomSheet/BottomSheet';
import { useLanguage } from '@/hooks/useLanguage';
import styles from './CheckoutBottomSheetSplitInfo.module.scss';

export const ServiceFeeBottomSheetInfo = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();
  return (
    <BottomSheet onClose={onClick} closable={false}>
      <div className={styles.infoContainer} dir={isRTL ? 'rtl' : 'ltr'}>
        <h2>{t('checkout.serviceFeeInfo.serviceFee')}</h2>
        <p className={styles.bodyText}>{t('checkout.serviceFeeInfo.feeDescription')}</p>
        <button className={styles.bottomSheetButton} onClick={onClick}>
          {t('checkout.serviceFeeInfo.gotIt')}
        </button>
      </div>
    </BottomSheet>
  );
};
